export const arrow_left = () => (
  <path
    d="M19 12H5m0 0l7 7m-7-7l7-7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
